import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'xqnr-footer-marketing',
    templateUrl: './footer-marketing.component.pug',
    styleUrls: ['./footer-marketing.component.scss'],
    standalone: false
})
export class FooterMarketingComponent implements OnInit {
  currYear = new Date().getFullYear();

  constructor() {}

  ngOnInit() {}

}
